import { render, staticRenderFns } from "./module4.vue?vue&type=template&id=342e4cbe&scoped=true"
import script from "./module4.vue?vue&type=script&lang=js"
export * from "./module4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342e4cbe",
  null
  
)

export default component.exports